import faviconUrl from "./assets/png/isotipo.png";
import logoUrl from "./assets/png/Logo.png";
import homeBannerUrl from "./assets/jpg/home-banner.jpeg";
import historiaFamilyUrl from "./assets/jpg/familia-hikarai.jpeg";
import proximamenteCollectionBgUrl from "./assets/jpg/theapothecaryscurse.png";
import { siteConfig, type SiteNavId } from "./config/site";
import { bindStitchImages } from "./stitch-bind";
import { initProductGallery } from "./product-gallery";
import { initDataDrivenPages } from "./data-pages";
import { buildWhatsAppApothecaryMysteryBoxPreorderUrl } from "./whatsapp";

function injectFavicons(): void {
  if (document.querySelector("link[rel='icon'][data-hikarai-favicon]")) {
    return;
  }
  const icon = document.createElement("link");
  icon.rel = "icon";
  icon.type = "image/png";
  icon.href = faviconUrl;
  icon.dataset.hikaraiFavicon = "";
  document.head.appendChild(icon);

  const apple = document.createElement("link");
  apple.rel = "apple-touch-icon";
  apple.href = faviconUrl;
  apple.dataset.hikaraiApple = "";
  document.head.appendChild(apple);
}

injectFavicons();

function initBrandLogos(): void {
  for (const img of document.querySelectorAll<HTMLImageElement>("[data-brand-logo]")) {
    img.src = logoUrl;
  }
}

function parseActiveNav(raw: string | undefined): SiteNavId | undefined {
  if (raw === undefined || raw === "") return undefined;
  for (const item of siteConfig.nav) {
    if (item.id === raw) return item.id;
  }
  return undefined;
}

function syncShippingBarHeight(): void {
  const bar = document.querySelector("[data-site-shipping-bar]");
  if (!(bar instanceof HTMLElement)) return;
  const h = Math.ceil(bar.getBoundingClientRect().height);
  document.documentElement.style.setProperty("--site-shipping-bar-height", `${h}px`);
}

let shippingBarResizeBound = false;

function ensureShippingBarHeightSyncOnResize(): void {
  if (shippingBarResizeBound) return;
  shippingBarResizeBound = true;
  window.addEventListener("resize", syncShippingBarHeight);
}

function injectShippingBar(): void {
  if (document.querySelector("[data-site-shipping-bar]")) return;
  const bar = document.createElement("div");
  bar.className = "site-shipping-bar";
  bar.dataset.siteShippingBar = "";
  bar.setAttribute("role", "status");
  const inner = document.createElement("p");
  inner.className = "site-shipping-bar__text";
  inner.innerHTML =
    "Envío a todo el país. <strong>Envío gratis</strong> en pedidos superiores a $200.000 COP.";
  bar.appendChild(inner);
  document.body.insertBefore(bar, document.body.firstChild);
}

function initHomeHeroBanner(): void {
  for (const img of document.querySelectorAll<HTMLImageElement>("[data-home-hero-banner]")) {
    img.src = homeBannerUrl;
  }
}

/** Reemplaza `src/assets/jpg/familia-hikarai.jpeg` por tu foto real (mismo nombre). */
function initHistoriaFamilyPhoto(): void {
  for (const img of document.querySelectorAll<HTMLImageElement>("[data-historia-family-photo]")) {
    img.src = historiaFamilyUrl;
  }
}

function initProximamentePreorderCta(): void {
  const a = document.querySelector<HTMLAnchorElement>("[data-proximamente-preorder]");
  if (a === null) return;
  a.href = buildWhatsAppApothecaryMysteryBoxPreorderUrl();
}

/** Fondo portada próximamente: `src/assets/jpg/theapothecaryscurse.png` (The Apothecary's Curse). */
function initProximamenteCollectionBackground(): void {
  if (document.body.dataset.page !== "proximamente") return;
  for (const img of document.querySelectorAll<HTMLImageElement>("[data-proximamente-bg]")) {
    img.src = proximamenteCollectionBgUrl;
  }
}

function initNav(): void {
  const root = document.querySelector<HTMLUListElement>("[data-nav-root]");
  if (!root) return;

  const activeNav = parseActiveNav(document.body.dataset.activeNav);
  const fragment = document.createDocumentFragment();
  for (const item of siteConfig.nav) {
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.href = item.href;
    a.textContent = item.label;
    a.classList.add("site-nav__link");
    if (activeNav !== undefined && item.id === activeNav) {
      a.classList.add("site-nav__link--active");
      a.setAttribute("aria-current", "page");
    }
    li.appendChild(a);
    fragment.appendChild(li);
  }
  root.appendChild(fragment);
}

function main(): void {
  const isProximamente = document.body.dataset.page === "proximamente";

  if (!isProximamente) {
    injectShippingBar();
    ensureShippingBarHeightSyncOnResize();
    requestAnimationFrame(() => {
      syncShippingBarHeight();
    });
  }

  initBrandLogos();
  bindStitchImages(document);
  initProximamenteCollectionBackground();

  if (!isProximamente) {
    initHomeHeroBanner();
    initHistoriaFamilyPhoto();
  }

  initNav();
  initProximamentePreorderCta();

  if (!isProximamente) {
    initProductGallery();
  }

  initDataDrivenPages();
}

document.addEventListener("DOMContentLoaded", main);
